import { Navigate } from 'react-router-dom';

// import LoadingSpinner from './LoadingSpinner';

const ProtectedRoutes = ({ children }) => {
  
  let jwt = localStorage.getItem('jwt')


  if (!jwt) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoutes;